<div class="selectable-table">
  @if (loading) {
  <div class="selectable-table-loading">
    <ion-spinner name="dots" />
  </div>
  } @else {
  <table>
    <thead>
      <tr>
        <th class="toggle-cell"></th>
        @for (column of columns; track column.key) {
        <th>{{ column.label }}</th>
        }
      </tr>
    </thead>
    <tbody>
      @for (row of rows; track rowId(row)) {
      <tr>
        <td class="toggle-cell">
          <ion-toggle
            class="row-toggle"
            [checked]="selectedIds.has(rowId(row))"
            (ionChange)="toggleRow(rowId(row))"
          />
        </td>
        @for (column of columns; track column.key) {
        <td>{{ valueFor(row, column.key) }}</td>
        }
      </tr>
      }
    </tbody>
  </table>
  }
</div>
